/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customers_Col_PlanInputs */



/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Partner_Customers_Col_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customers_col_plan = /** @type {((inputs?: Partner_Customers_Col_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customers_Col_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarif")
	return /** @type {LocalizedString} */ ("Plan")
});